import { TableCell, TableRow, IconButton } from '@mui/material'
import CircleCheckbox from 'src/Component/CircleCheckbox'
import eyeIcon from 'src/assets/icons/eyeIcon.png'
import deleteIcon from 'src/assets/icons/deleteIcon.png'

type DataRowProps = {
  id: number
  name: string
  address: string
  latitude: string
  longitude: string
  rating: number
  selected: boolean
  onViewDetailsClick: (id: number) => void
  onDeleteClick: (id: number) => void
  onEditClick: (id: number) => void
  onSelect: (id: number) => void
}
const DataRow = ({
  id,
  name,
  address,
  latitude,
  longitude,
  rating,
  selected,
  onViewDetailsClick,
  onDeleteClick,
  onSelect,
  onEditClick,
}: DataRowProps) => {
  return (
    <TableRow hover tabIndex={-1}>
      <TableCell padding='checkbox'>
        <CircleCheckbox checked={selected} onChange={(checked) => onSelect(id)} />
      </TableCell>
      <TableCell onClick={() => onEditClick(id)}>
        {' '}
        <span
          style={{
            borderBottom: '1px solid white',
            cursor: 'pointer',
          }}
        >
          {name}
        </span>{' '}
      </TableCell>
      <TableCell>{address}</TableCell>
      <TableCell>{latitude}</TableCell>
      <TableCell>{longitude}</TableCell>
      <TableCell>{rating}</TableCell>
      <TableCell align='center'>
        <IconButton onClick={() => onViewDetailsClick(id)}>
          {' '}
          <img src={eyeIcon} alt='eyeIcon' />{' '}
        </IconButton>
        <IconButton onClick={() => onDeleteClick(id)}>
          {' '}
          <img src={deleteIcon} alt='deleteIcon' />{' '}
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default DataRow
